import { render } from "./BaseSelectForms.vue?vue&type=template&id=3c128c78"
import script from "./BaseSelectForms.vue?vue&type=script&lang=js"
export * from "./BaseSelectForms.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__